import { ApolloClient } from '@apollo/client';
import { PropertyType } from '../../domain/propertyTypes';
import { PostSubcategory } from '../../domain/postCategories';
import logger from '../../logger/logger';
import {
  fetchHeroArticle,
  fetchHighlights,
  fetchMostPopularArticles,
} from '../../../../services/post';
import { MostPopular } from '../../../../queries/homePage/mostPopular';
import { HighlightItem } from '../../../../queries/homePage/highlights';
import { resolved } from '../../utility/promiseHelper';
import { fetchRecommendedLocations } from '../../../../services/location';

export const fetchLandingPageTopContentData = async (
  apolloClient: ApolloClient<unknown>,
  {
    propertyType,
    postCategories,
    tag,
  }: {
    propertyType?: PropertyType;
    postCategories?: PostSubcategory[];
    tag?: string;
  },
) => {
  const isHomePage = !propertyType && !postCategories?.length;
  logger.logInfo(
    'homePageDataFetcher.fetchLandingPageTopContentData',
    'Begin with args',
    {
      propertyType,
      postCategories,
    },
  );
  const [
    heroArticleData,
    popularArticlesData,
    highlightsData,
    recommendedLocations,
  ] = await Promise.allSettled([
    fetchHeroArticle(apolloClient, {
      propertyType,
      postCategory: postCategories,
      tag,
    }),
    isHomePage
      ? Promise.resolve([] as MostPopular[])
      : fetchMostPopularArticles(apolloClient, {
          propertyType: propertyType ? [propertyType] : undefined,
          postCategory: postCategories,
          tag,
          popularFromDate: 60,
          perPage: 3,
        }),
    isHomePage
      ? fetchHighlights(apolloClient)
      : Promise.resolve([] as HighlightItem[]),
    fetchRecommendedLocations(apolloClient),
  ]);

  return {
    heroArticle: resolved(heroArticleData, null),
    mostPopular: resolved(popularArticlesData, []),
    highlights: resolved(highlightsData, []),
    recommendedLocations: resolved(recommendedLocations, []),
  };
};
